export const basePaths = {
  admin_panel: '/admin-panel',
  client_panel: '/client-panel'
}

export const clientPaths = {
  buyer: 'buyer',
  seller: 'seller'
}

export const paths = {
  active_offers: 'active-offers',
  add_demand: 'add-demand',
  add_offer: 'add-offer',
  add_planned_offer: 'add-planned-offer',
  additional_information: 'additional-information',
  confirmation: 'confirmation',
  demand_data: 'demand-data',
  email_verification: 'email-verification',
  file_upload: 'file-upload',
  format_choice: 'format-choice',
  logout: 'logout',
  login: 'login',
  match_data: 'match-data',
  matches: 'matches',
  matching_offers: 'matching-offers',
  matching: 'matching',
  offer_data: 'offer-data',
  offered_matches: 'offered-matches',
  personal_data: 'personal-data',
  registration_success: 'registration-success',
  registration: 'registration',
  search: 'search',
  success: 'success'
}

export const adminPanelPaths = {
  matches: `${basePaths.admin_panel}/${paths.matches}`,
  matches_search: `${basePaths.admin_panel}/${paths.matches}/${paths.search}`,
  confirmation: `${basePaths.admin_panel}/${paths.confirmation}`,
  registration: `${basePaths.admin_panel}/${paths.registration}`,
  registration_success: `${basePaths.admin_panel}/${paths.registration_success}`,
  buyer: {
    search: `${basePaths.admin_panel}/${clientPaths.buyer}/${paths.search}`,
    add_demand: `${basePaths.admin_panel}/${clientPaths.buyer}/${paths.add_demand}`,
    confirmation: `${basePaths.admin_panel}/${clientPaths.buyer}/${paths.confirmation}`
  },
  seller: {
    search: `${basePaths.admin_panel}/${clientPaths.seller}/${paths.search}`,
    additional_information: `${basePaths.admin_panel}/${clientPaths.seller}/${paths.additional_information}`,
    confirmation: `${basePaths.admin_panel}/${clientPaths.seller}/${paths.confirmation}`
  }
}

export const clientPanelPaths = {
  personal_data: `${basePaths.client_panel}/${paths.personal_data}`,
  offer_data: `${basePaths.client_panel}/${paths.offer_data}`,
  match_data: `${basePaths.client_panel}/${paths.match_data}`,
  matches: `${basePaths.client_panel}/${paths.matches}`,
  demand_data: `${basePaths.client_panel}/${paths.demand_data}`,
  add_offer: `${basePaths.client_panel}/${paths.add_offer}`,
  add_planned_offer: `${basePaths.client_panel}/${paths.add_planned_offer}`,
  add_demand: `${basePaths.client_panel}/${paths.add_demand}`,
  additional_information: `${basePaths.client_panel}/${paths.additional_information}`,
  confirmation: `${basePaths.client_panel}/${paths.confirmation}`
}
